import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { MessageQueueItem } from 'app/integration/message-log/services/message-queue-item';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class MessageQueueService {
  protected baseUrl = `${environment.estnhsApi}/integration`;

  constructor(private http: HttpClient) {}

  public getChain(queueId: string): Observable<Array<MessageQueueItem>> {
    const url = `${this.baseUrl}/message-queue/${queueId}/chain`;
    return this.http.get(url).pipe(map((resp) => resp as Array<MessageQueueItem>));
  }

  public stopResend(queueId: string): Observable<any> {
    const url = `${this.baseUrl}/message-queue/${queueId}/stop`;
    return this.http.post(url, null).pipe(map((resp) => resp as any));
  }

  public getSeries(queueId: string): Observable<Array<MessageQueueItem>> {
    const url = `${this.baseUrl}/message-queue/${queueId}/series`;
    return this.http.get(url).pipe(map((resp) => resp as Array<MessageQueueItem>));
  }
}
